/**
 * ProgressionManager: Persistent Metagame, Bank, Perks Shop & Daily Missions
 * Drives long-term retention, dopamine rewards, and repeat play loops.
 */

export const PERKS = {
  SHIELD: {
    id: 'perk_shield',
    name: 'Aegis Thunder Shield',
    desc: 'Survives 1 fatal hazard hit per run with electric shockwave!',
    price: 15,
    icon: '🛡️'
  },
  MAGNET: {
    id: 'perk_magnet',
    name: 'Magnetic Pompadour',
    desc: 'Pulls Golden Vinyls and Zeus Bolts towards you from distance!',
    price: 25,
    icon: '🧲'
  },
  FUEL: {
    id: 'perk_fuel',
    name: 'Hyper Overdrive Fuel',
    desc: 'Overdrive charges 40% faster and lasts 2.5 seconds longer!',
    price: 20,
    icon: '⚡'
  },
  MIDAS: {
    id: 'perk_midas',
    name: 'Golden Midas Suit',
    desc: '2X Score on all vinyl pickups + double bank rewards!',
    price: 50,
    icon: '👑'
  }
};

export const MISSIONS = [
  {
    id: 'slide_master',
    title: 'Slide Shredder',
    desc: 'Perform 4 Rockstar Knee Slides in one run',
    target: 4,
    reward: 25,
    icon: '🎸'
  },
  {
    id: 'gravity_maestro',
    title: 'Anti-Gravity King',
    desc: 'Flip gravity 6 times in one run',
    target: 6,
    reward: 30,
    icon: '⚡'
  },
  {
    id: 'close_call_hero',
    title: 'Danger Close',
    desc: 'Achieve 3 Close-Call grazes near hazards',
    target: 3,
    reward: 40,
    icon: '🔥'
  }
];

class Progression {
  getBankVinyls() {
    return parseInt(localStorage.getItem('zelvis_bank_vinyls') || '20', 10); // Start with 20 welcome vinyls
  }

  addBankVinyls(amount) {
    const current = this.getBankVinyls();
    const updated = current + amount;
    localStorage.setItem('zelvis_bank_vinyls', updated.toString());
    return updated;
  }

  hasPerk(perkId) {
    return localStorage.getItem(`zelvis_${perkId}`) === 'true';
  }

  setPerk(perkId, active) {
    localStorage.setItem(`zelvis_${perkId}`, active ? 'true' : 'false');
  }

  buyPerk(perkId) {
    const perk = Object.values(PERKS).find(p => p.id === perkId);
    if (!perk) return false;
    const bank = this.getBankVinyls();
    if (bank >= perk.price) {
      this.addBankVinyls(-perk.price);
      this.setPerk(perkId, true);
      return true;
    }
    return false;
  }

  isMissionCompleted(missionId) {
    return localStorage.getItem(`zelvis_mission_${missionId}`) === 'completed';
  }

  claimMission(missionId) {
    const mission = MISSIONS.find(m => m.id === missionId);
    if (!mission) return false;
    if (!this.isMissionCompleted(missionId)) {
      localStorage.setItem(`zelvis_mission_${missionId}`, 'completed');
      this.addBankVinyls(mission.reward);
      return true;
    }
    return false;
  }
}

export const progression = new Progression();
